// src/CcpAdminUsers/EditForm/EditModal.js
import React, { useState } from "react";
import {
  DialogContent,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Alert,
} from "@mui/material";
import { updateSchoolUser } from "../../../config/firebase";
import ModalDialogTitle from "../../common/ModalDialogTitle";
import ModalActions from "../../common/ModalActions";

const EditModal = ({ user, onSuccess, onClose }) => {
  const [name, setName] = useState(user.name);
  const [school_name, setSchoolName] = useState(user.school_name);
  const [title, setTitle] = useState(user.title);
  const [flag, setFlag] = useState(user.flag);
  const [userType, setUserType] = useState(user.userType);
  const [email, setEmail] = useState(user.email);
  const [phone, setPhone] = useState(user.phone);
  const [school_id, setSchoolId] = useState(user.school_id);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  // Function to format phone number with dashes as the user types
  const formatPhoneNumber = (input) => {
    // Remove non-numeric characters
    const cleaned = ("" + input).replace(/\D/g, "");

    // Apply phone number formatting
    const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      return `${match[1]}-${match[2]}-${match[3]}`;
    }
    return input;
  };

  const handlePhoneChange = (e) => {
    // Format phone number as the user types
    const formattedPhone = formatPhoneNumber(e.target.value);
    setPhone(formattedPhone);
  };

  const handleSubmit = async () => {
    setLoading(true);
    setError("");

    try {
      const result = await updateSchoolUser(
        user.id,
        name,
        school_name,
        email,
        title,
        phone,
        flag,
        userType,
        school_id
      );

      if (result.success) {
        onSuccess();
      } else {
        setError(result.message || "Failed to update user");
      }
    } catch (error) {
      console.error("Error updating user:", error);
      setError("An unexpected error occurred while updating the user");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <ModalDialogTitle onClose={onClose}>Edit User</ModalDialogTitle>
      <DialogContent>
        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}
        <TextField
          autoFocus
          margin="dense"
          label="Name"
          type="text"
          fullWidth
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
        <TextField
          autoFocus
          margin="dense"
          label="School Name"
          type="text"
          fullWidth
          value={school_name}
          onChange={(e) => setSchoolName(e.target.value)}
        />
        <TextField
          margin="dense"
          label="Email"
          type="email"
          fullWidth
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <TextField
          margin="dense"
          label="Title"
          type="text"
          fullWidth
          value={title}
          onChange={(e) => setTitle(e.target.value)}
        />
        <TextField
          margin="dense"
          label="Phone"
          type="text"
          fullWidth
          value={phone}
          onChange={handlePhoneChange}
        />
        <TextField
          margin="dense"
          label="School Id"
          type="text"
          fullWidth
          value={school_id}
          onChange={(e) => setSchoolId(e.target.value)}
        />
        <FormControl fullWidth margin="dense">
          <InputLabel>Flag</InputLabel>
          <Select
            value={flag}
            onChange={(e) => setFlag(e.target.value)}
            label="Flag"
          >
            <MenuItem value="TechPrep">TechPrep</MenuItem>
            <MenuItem value="CCP">CCP</MenuItem>
            <MenuItem value="Both">Both</MenuItem>
          </Select>
        </FormControl>
        <FormControl fullWidth margin="dense">
          <InputLabel>User Type</InputLabel>
          <Select
            value={userType}
            onChange={(e) => setUserType(e.target.value)}
            label="User Type"
          >
            <MenuItem value="RCPA">RCPA</MenuItem>
            <MenuItem value="GPA">GPA</MenuItem>
            <MenuItem value="DPA">DPA</MenuItem>
            <MenuItem value="tpcoordinator">Tech Prep Coordinator</MenuItem>
            <MenuItem value="tpinstructor">Tech Prep Instructor</MenuItem>
          </Select>
        </FormControl>
      </DialogContent>
      <ModalActions onSave={handleSubmit} saving={loading} />
    </>
  );
};

export default EditModal;
